import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { Toast } from 'primereact/toast';
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Navbar, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useForm } from 'react-hook-form';
import { BiLeftArrowAlt } from "react-icons/bi";
import { HiArrowLeft } from 'react-icons/hi';
import { MdOutlineCloudUpload } from 'react-icons/md';
import Loader from "react-js-loader";
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../Layout/Header";
import { getEndpointUrl, getTimestamp } from "../../Utils/Common";
import FormOnChange from "./FormOnChange";
import SidebarCategoryForm from './SidebarCategoryForm';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const FormCategory = () => {
    const { control, register, handleSubmit, formState: { errors }, reset } = useForm();
    
    const [isLoading, setLoading] = useState(false);

    const [isSaveLoading, setSaveLoading] = useState(false);

    const toast = useRef(null);

    const params = useParams();

    const navigate = useNavigate();

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const [formElement, setFormElement] = useState([]);

    const [accesToken] = useState(JSON.parse(localStorage.getItem('credentials')) || []);

    const [saveData, setSaveData] = useState(null);

    const fetchFormElement = useCallback(async (category) => {
        setLoading(true);

        fetch(`/form/${category}.json`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`
            })
        }).then(response => response.json()).then(json => {
            setFormElement(json);

            setLoading(false);
        }).catch(error => {
            setLoading(true);
        });
    }, []);

    const fetchData = useCallback(async (category) => {
        setLoading(true);

        fetch(getEndpointUrl() + `/checkpoint/category/${category}/${params.item_id}?v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`
            })
        }).then(response => response.json()).then(json => {

            setSaveData(json.results);

            setLoading(false);
        }).catch(error => {
            setLoading(true);
        });
    }, []);

    useEffect(() => {
        fetchFormElement(params.category);
        fetchData(params.category);
    }, [params]);

    const onCallback = useCallback((e) => {
        automaticSaveData(e);
    }, []);

    const automaticSaveData = async (data) => {
        setSaveLoading(data);
        await sleep(2000);
    };

    // const finish = () => {
    //     setLoading(true);
    //     fetch(getEndpointUrl() + `/checkpoint/finish/${params.item_id !== undefined ? params.item_id : 0}/${params.category}?v=${getTimestamp()}`, {
    //         method: 'POST',
    //         headers: new Headers({
    //             Authorization: `Bearer ${accesToken}`,
    //         }),
    //     }).then(response => response.json()).then(json => {

    //         if (json.status === 'ok') {
    //             toast.current.show({ severity: 'success', summary: 'Berhasil', detail: 'Form inspeksi berhasil disimpan.' });
    //         } else {

    //         }

    //         setLoading(false);

    //         clearTimeout();
    //     }).catch(error => {
    //         setLoading(true);

    //         setTimeout(() => fetchData(params.offer_id), 1000);
    //     });
    // }

    return (
        <>
            <Toast ref={toast} />
            <SidebarCategoryForm show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            {isLoading ?
                <Container className="mt-5">
                    <div className="text-center mt-5">
                        <Loader type="bubble-scale" bgColor={"#EF9A9A"} size={100} />
                    </div>
                </Container> :
                <>
                    <Helmet>
                        <title>{formElement.title}</title>
                    </Helmet>

                    <div className="d-block d-sm-none">
                        <Navbar expand="lg" className="mainNavbar border-bottom mb-3" fixed="top">
                            <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                                <HiArrowLeft />
                            </a>
                            <strong className="me-auto navTitle">{formElement.title} <br />

                                {isSaveLoading ?
                                    <small className="text-muted fw-normal fst-italic">
                                        <FontAwesomeIcon icon={faSpinner} spin={true} /><small className="ms-2">Menyimpan...</small>
                                    </small> :
                                    <small className="text-muted fw-normal fst-italic">
                                        <MdOutlineCloudUpload /><small className="ms-2">Data tersimpan</small>
                                    </small>
                                }
                            </strong>
                            <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                        </Navbar>
                    </div>
                    <div className="d-none d-sm-inline">
                        <Header />
                    </div>
                    <Container className="mt-4 mb-5 pb-5">
                        <div className="d-none d-sm-inline">
                            <Row className="mb-3">
                                <Col md={12}>
                                    <strong className="me-auto navTitle">{formElement.title}</strong>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button variant="secondary" onClick={() => navigate(-1)} className="pe-3"><BiLeftArrowAlt /> Kembali</Button>
                                </Col>
                                <Col>
                                    <div className="d-flex justify-content-end">
                                        {isSaveLoading ?
                                            <div className="text-muted pt-2">
                                                <FontAwesomeIcon icon={faSpinner} spin={true} /><small className="ms-2">Menyimpan...</small>
                                            </div> :
                                            <div className="text-muted pt-2">
                                                <MdOutlineCloudUpload /><small className="ms-2">Data tersimpan</small>
                                            </div>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="mt-5 pt-5">
                            {saveData !== null &&
                                formElement.elements?.length > 0 && formElement.elements.map((el, key) => (
                                    <FormOnChange setLoading={(e) => onCallback(e)} element={el} entry={saveData} fKey={key} key={key} />
                                ))
                            }
                        </div>
                    </Container>
                    {/* <Navbar expand="lg" className="mainNavbar border-top" fixed="bottom">
                        <Container>
                            <Link to={'#'} onClick={() => navigate(-1)} className="btn btn-outline-secondary"> <HiArrowLeft /> Kembali</Link>
                            <Button variant="btn btn-success" type="button" onClick={finish} disabled={isLoading}>Simpan</Button>
                        </Container>
                    </Navbar> */}
                </>
            }
        </>
    );
}

export default FormCategory;
